<template>
    <v-container fluid>
        <v-row>
            <v-col sm="12">
                <v-card>
                    <lieferant-details :lieferant-daten="lieferantDetailData" @success="loadLieferantDetails" />
                </v-card>
            </v-col>
            <v-col v-if="isLieferantMain" sm="12">
                <v-card>
                    <benutzer-liste :benutzer-list="lieferantBenutzerData" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_LIEFERANTADMINISTRATION } from '../store';
import { NAME as NAME_LIEFERANT } from '@/areas/lieferant/store';
import { NAME as NAME_GENERAL } from '@/store/modules/general';
import { NAME as NAME_SECURITY } from '@/store/modules/security';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';

const lieferantAdministrationModul = namespace(NAME_LIEFERANTADMINISTRATION);
const lieferantModul = namespace(NAME_LIEFERANT);
const generalModul = namespace(NAME_GENERAL);
const securityModul = namespace(NAME_SECURITY);
const headerModul = namespace(NAME_HEADERNOTIFICATION);

import { HASACCESS, BENUTZERINFO } from '@/store/modules/security/getters';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';
import { NEW_ALERT } from '@/store/modules/headerNotification/actions';
import { GETLIEFERANTDETAILDATA } from '@/areas/lieferant/store/getters';
import { GETLIEFERANTBENUTZERDATA } from '@/areas/lieferantadministration/store/getters';
import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import LieferantBenutzerListe from './LieferantBenutzerListe.vue';
import LieferantDetails from './LieferantDetails.vue';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';
import { GET_BENUTZER_BY_ID } from '@/areas/lieferantadministration/store/actions';
import { BenutzerInfoApiDto, LieferantDetailApiDto } from '@/api-schema';
import { LOAD_LIEFERANT_DETAILS } from '@/areas/lieferant/store/actions';

@Component({
    components: {
        BenutzerListe: LieferantBenutzerListe,
        LieferantDetails
    }
})
export default class LieferantEinstellungen extends Vue {
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;
    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Getter(BENUTZERINFO) benutzerInfo!: BenutzerInfoApiDto;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;
    @headerModul.Action(NEW_ALERT) alertMessage!: Function;
    @lieferantAdministrationModul.Action(GET_BENUTZER_BY_ID) getBenutzer!: Function;
    @lieferantModul.Getter(GETLIEFERANTDETAILDATA) lieferantDetailData!: LieferantDetailApiDto;
    @lieferantModul.Action(LOAD_LIEFERANT_DETAILS) loadLieferantDetails!: Function;
    @lieferantAdministrationModul.Getter(GETLIEFERANTBENUTZERDATA) lieferantBenutzerData!: Array<TeilnehmerBenutzerDto>;
    mounted() {
        this.setSubTitle(this.$t('lieferant.einstellungen.subtitle'));
        this.setFooterTitle('S530');
        if (!this.hasAccess('Navigation.LieferantEinstellungen')) {
            this.setAccessDenied(true);
            this.alertMessage({ text: this.$t('errormessage.noaccesspage') });
        } else {
            this.setAccessDenied(false);
            if (this.isLieferantMain) {
                this.getBenutzer();
            }
            this.loadLieferantDetails(this.benutzerInfo.tvsLieferantenNummer);
        }
    }
    get isLieferantMain(): boolean {
        return this.benutzerInfo?.rollen?.includes('LieferantMain') ?? false;
    }
}
</script>
